import React, { useEffect } from 'react'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { observer } from 'mobx-react'

const AddEditTagModal = ({ initialValue, edit }) => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  useEffect(() => {
    if (initialValue) {
      changeValues(initialValue, 'name')
    }
  }, [initialValue, changeValues])

  return (
    <FormField>
      <FormLabel isRequired>{edit ? 'Edit the tag' : 'Add a tag'}:</FormLabel>
      <FormInput isError={check('name')}>
        <input
          name='name'
          onChange={(e) => changeValues(e.target.value, 'name')}
          placeholder='Enter the tag'
          value={modalValue?.name || ''}
          autoFocus
        />
      </FormInput>
    </FormField>
  )
}

export default observer(AddEditTagModal)
